import React, { useEffect, useMemo, useState } from 'react';
import { Download, Loader2, MessageCircle } from 'lucide-react';
import { API } from '../../lib/api';
import { waUrl } from '../../lib/waShare';
import { niceDate, niceSlot } from '../../lib/aptMessages';

const save = (blob, name) => {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = name;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(a.href); }, 1000);
};

// Thank-you screen card: preview, save, and share to WhatsApp.
export const BookingCardShare = ({ confirmed }) => {
  const [blob, setBlob] = useState(null);
  const [failed, setFailed] = useState(false);
  const src = `${API}/public/appointments/card/${confirmed.card_token}`;
  const name = `${(confirmed.ref_no || 'booking').replace(/[^A-Za-z0-9]+/g, '-')}.png`;
  const text = `My booking ${confirmed.ref_no} · ${confirmed.service_type} · ${niceDate(confirmed.slot_date)} · ${niceSlot(confirmed.slot_window)}`;

  useEffect(() => {
    fetch(src).then((r) => (r.ok ? r.blob() : Promise.reject())).then(setBlob).catch(() => setFailed(true));
  }, [src]);

  const preview = useMemo(() => (blob ? URL.createObjectURL(blob) : ''), [blob]);
  useEffect(() => () => preview && URL.revokeObjectURL(preview), [preview]);

  // No await before navigator.share, so iOS keeps the tap gesture.
  const share = () => {
    const file = new File([blob], name, { type: 'image/png' });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      navigator.share({ files: [file], title: `Booking ${confirmed.ref_no}`, text }).catch(() => {});
      return;
    }
    save(blob, name);
    window.open(waUrl('', text), '_blank', 'noopener');
  };

  if (failed) return null;
  return (
    <div className="mt-5" data-testid="booking-card">
      {blob ? <img src={preview} alt={`Booking card ${confirmed.ref_no}`} className="w-full rounded-xl border border-slate-200 shadow-sm" data-testid="booking-card-img" />
        : <div className="flex aspect-[4/5] items-center justify-center rounded-xl border border-slate-200 bg-slate-50"><Loader2 className="animate-spin text-slate-400" /></div>}
      <div className="mt-3 grid grid-cols-2 gap-2">
        <button type="button" disabled={!blob} onClick={() => save(blob, name)} className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-50" data-testid="booking-card-save">
          <Download size={15} /> Save card
        </button>
        <button type="button" disabled={!blob} onClick={share} className="inline-flex items-center justify-center gap-1.5 rounded-lg px-3 py-2.5 text-sm font-semibold disabled:opacity-50" style={{ background: '#16a34a', color: '#fff' }} data-testid="booking-card-share">
          <MessageCircle size={15} /> Share to WhatsApp
        </button>
      </div>
    </div>
  );
};
